// extracted by mini-css-extract-plugin
export default {"required":"TextArea_required__2XDZM","textarea":"TextArea_textarea__rJdmE"};